/* ===================================================================
 * The House of JK — storefront runtime
 * ===================================================================
 * Replaces the preview bundle's fake commerce layer entirely.
 *
 *   Cart          → /cart/add.js, /cart/change.js, /cart.js  (Ajax Cart API)
 *   Checkout      → real POST to /cart with name="checkout"
 *   Variants      → resolved against the live product JSON from Liquid
 *   Search        → /search/suggest.json (Predictive Search API)
 *   Wishlist      → localStorage, PRODUCT HANDLES only
 *   Compare       → localStorage, PRODUCT HANDLES only
 *   Recently viewed → localStorage handles, hydrated via Section Rendering API
 *
 * There is not a single hardcoded product anywhere in this file.
 * =================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
   * Environment
   * ------------------------------------------------------------- */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MONEY_FORMAT = (window.HOJ && window.HOJ.moneyFormat) || '${{amount}}';
  var STRINGS = (window.HOJ && window.HOJ.strings) || {};

  var LS = {
    wishlist: 'hoj:wishlist',
    compare: 'hoj:compare',
    recent: 'hoj:recently-viewed'
  };

  var MAX_COMPARE = 4;
  var MAX_RECENT = 12;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) { throw Object.assign(new Error(body.description || body.message || r.statusText), { body: body }); }
        return body;
      });
    });
  }

  /* Shopify's money filter, mirrored client-side so Ajax-rendered
     amounts match server-rendered ones exactly. */
  function formatMoney(cents, format) {
    var fmt = format || MONEY_FORMAT;
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function pad(num, size) {
      var s = String(num);
      while (s.length < size) { s = '0' + s; }
      return s;
    }
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) { return 0; }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }

    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2); pad(0, 0);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------------------------------------------------------------
   * localStorage helpers — handles only, never product objects
   * ------------------------------------------------------------- */
  function readList(key) {
    try {
      var raw = window.localStorage.getItem(key);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function writeList(key, list) {
    try { window.localStorage.setItem(key, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }
  function toggleInList(key, handle, max) {
    var list = readList(key);
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); }
    else {
      list.push(handle);
      if (max && list.length > max) { list.shift(); }
    }
    writeList(key, list);
    return list.indexOf(handle) > -1;
  }

  /* ---------------------------------------------------------------
   * Toast — reuses .add-toast markup from the original design
   * ------------------------------------------------------------- */
  var toastTimer;
  function toast(message, variant) {
    var el = $('[data-add-toast]');
    if (!el) { return; }
    var textEl = $('[data-add-toast-text]', el);
    if (textEl) { textEl.innerHTML = message; }
    el.classList.toggle('compare-notice', variant === 'compare');
    el.classList.add('show');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { el.classList.remove('show'); }, 2600);
  }

  /* ===============================================================
   * CART — Shopify Ajax Cart API
   * ============================================================= */
  var Cart = {
    drawer: null,
    overlay: null,

    init: function () {
      Cart.drawer = $('[data-cart-drawer]');
      Cart.overlay = $('[data-cart-overlay]');
      if (!Cart.drawer) { return; }

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-open]')) { e.preventDefault(); Cart.open(); }
        if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { Cart.close(); }

        var line = e.target.closest('[data-cart-line]');
        if (!line) { return; }
        var key = line.getAttribute('data-line-key');
        var qtyEl = $('[data-qty-value]', line);
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;

        if (e.target.closest('[data-qty-up]')) { Cart.change(key, qty + 1); }
        else if (e.target.closest('[data-qty-down]')) { Cart.change(key, Math.max(0, qty - 1)); }
        else if (e.target.closest('[data-line-remove]')) { Cart.change(key, 0); }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { Cart.close(); }
      });
    },

    open: function () {
      if (!Cart.drawer) { return; }
      Cart.drawer.classList.add('open');
      Cart.drawer.setAttribute('aria-hidden', 'false');
      if (Cart.overlay) { Cart.overlay.classList.add('show'); }
    },
    close: function () {
      if (!Cart.drawer) { return; }
      Cart.drawer.classList.remove('open');
      Cart.drawer.setAttribute('aria-hidden', 'true');
      if (Cart.overlay) { Cart.overlay.classList.remove('show'); }
    },

    add: function (variantId, quantity, properties) {
      var payload = { items: [{ id: Number(variantId), quantity: quantity || 1 }] };
      if (properties) { payload.items[0].properties = properties; }
      return fetchJSON(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return Cart.refresh().then(function () { return res; });
      });
    },

    change: function (key, quantity) {
      if (Cart.drawer) { Cart.drawer.classList.add('is-busy'); }
      return fetchJSON(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function () {
        return Cart.refresh();
      }).catch(function (err) {
        toast(err.message || 'Cart error');
      }).then(function () {
        if (Cart.drawer) { Cart.drawer.classList.remove('is-busy'); }
      });
    },

    /* Re-render the drawer from the server so markup, money formatting,
       discounts and translations always match a full page load. */
    refresh: function () {
      return fetch(ROOT + '?section_id=hoj-cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshDrawer = doc.querySelector('[data-cart-drawer]');
          var freshToast = doc.querySelector('[data-add-toast]');
          if (freshDrawer && Cart.drawer) {
            var wasOpen = Cart.drawer.classList.contains('open');
            $('[data-cart-items]', Cart.drawer).innerHTML = $('[data-cart-items]', freshDrawer).innerHTML;
            var oldFooter = $('[data-cart-footer]', Cart.drawer);
            var newFooter = $('[data-cart-footer]', freshDrawer);
            if (oldFooter && newFooter) { oldFooter.outerHTML = newFooter.outerHTML; }
            if (wasOpen) { Cart.open(); }
          }
          if (freshToast) { /* keeps toast markup in sync with locale changes */ }
          return fetchJSON(ROOT + 'cart.js');
        })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('hoj:cart:updated', { detail: cart }));
          return cart;
        })
        .catch(function () { /* keep the page usable if the fetch fails */ });
    }
  };

  /* ===============================================================
   * PRODUCT PAGE — real variants, real add to cart
   * ============================================================= */
  var Product = {
    init: function () {
      var section = $('[data-product-section]');
      if (!section) { return; }

      var jsonEl = $('#product-data', section);
      if (!jsonEl) { return; }

      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      if (!product || !product.variants) { return; }

      var mediaMapEl = $('[data-pdp-media-map]', section);
      var mediaMap = {};
      if (mediaMapEl) { try { mediaMap = JSON.parse(mediaMapEl.textContent); } catch (e) {} }

      var form = $('[data-pdp-form]', section);
      var idInput = $('[data-pdp-variant-id]', section);
      var addBtn = $('[data-pdp-add]', section);
      var priceEl = $('[data-pdp-price]', section);
      var stockEl = $('[data-pdp-stock]', section);
      var skuEl = $('[data-pdp-sku]', section);
      var skuRow = $('[data-pdp-sku-row]', section);
      var qtyInput = $('[data-pdp-qty]', section);

      /* Track the currently selected option values, seeded from Liquid. */
      var selected = [];
      $$('[data-option-index]', section).forEach(function (group) {
        if (!group.classList.contains('pdp-option')) { return; }
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var active = $('[data-option-value][aria-pressed="true"]', group);
        selected[idx] = active ? active.getAttribute('data-value') : null;
      });

      function findVariant() {
        return product.variants.filter(function (v) {
          return selected.every(function (val, i) {
            return val == null || v.options[i] === val;
          });
        })[0] || null;
      }

      /* Grey out option values that cannot combine with the current
         selection — driven purely by product.variants. */
      function refreshAvailability() {
        $$('.pdp-option', section).forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          $$('[data-option-value]', group).forEach(function (btn) {
            var value = btn.getAttribute('data-value');
            var probe = selected.slice();
            probe[idx] = value;
            var possible = product.variants.some(function (v) {
              return v.available && probe.every(function (val, i) {
                return val == null || v.options[i] === val;
              });
            });
            btn.classList.toggle('is-unavailable', !possible);
          });
        });
      }

      function showMediaForVariant(variant) {
        if (!variant) { return; }
        var mediaId = mediaMap[variant.id];
        if (!mediaId) { return; }
        Gallery.show(String(mediaId));
      }

      function update(variant) {
        if (!variant) {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute('data-label-soldout');
          }
          if (stockEl) {
            stockEl.setAttribute('data-in-stock', 'false');
            stockEl.textContent = STRINGS.unavailable || addBtn.getAttribute('data-label-soldout');
          }
          return;
        }

        if (idInput) { idInput.value = variant.id; }

        if (priceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceEl.innerHTML =
              '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
              '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
          } else {
            priceEl.textContent = formatMoney(variant.price);
          }
        }

        if (stockEl) {
          stockEl.setAttribute('data-in-stock', variant.available ? 'true' : 'false');
          stockEl.textContent = variant.available
            ? (STRINGS.in_stock || stockEl.textContent)
            : (STRINGS.sold_out || addBtn.getAttribute('data-label-soldout'));
        }

        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available
            ? addBtn.getAttribute('data-label-default')
            : addBtn.getAttribute('data-label-soldout');
        }

        if (skuEl) {
          skuEl.textContent = variant.sku || '';
          if (skuRow) { skuRow.hidden = !variant.sku; }
        }

        showMediaForVariant(variant);

        /* Keep the URL shareable and back-button correct. */
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      section.addEventListener('click', function (e) {
        var swatch = e.target.closest('[data-option-value]');
        if (swatch) {
          var group = swatch.closest('.pdp-option');
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          selected[idx] = swatch.getAttribute('data-value');
          $$('[data-option-value]', group).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          swatch.setAttribute('aria-pressed', 'true');
          var label = $('[data-option-selected]', group);
          if (label) { label.textContent = selected[idx]; }
          refreshAvailability();
          update(findVariant());
          return;
        }

        var step = e.target.closest('[data-qty-step]');
        if (step && qtyInput) {
          var delta = parseInt(step.getAttribute('data-qty-step'), 10);
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        }
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var variantId = idInput ? idInput.value : null;
          if (!variantId || !addBtn || addBtn.disabled) { return; }

          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          addBtn.classList.add('is-loading');
          addBtn.textContent = addBtn.getAttribute('data-label-adding');

          Cart.add(variantId, qty)
            .then(function () {
              addBtn.textContent = addBtn.getAttribute('data-label-added');
              toast('<strong>' + product.title + '</strong> ' + (STRINGS.to_cart || ''));
              Cart.open();
              window.setTimeout(function () {
                addBtn.textContent = addBtn.getAttribute('data-label-default');
              }, 1800);
            })
            .catch(function (err) {
              toast(err.message || 'Could not add to cart');
              addBtn.textContent = addBtn.getAttribute('data-label-default');
            })
            .then(function () { addBtn.classList.remove('is-loading'); });
        });
      }

      refreshAvailability();
      Recent.record(product.handle);
    }
  };

  /* ---------------------------------------------------------------
   * PDP gallery
   * ------------------------------------------------------------- */
  var Gallery = {
    init: function () {
      var wrap = $('[data-pdp-gallery]');
      if (!wrap) { return; }
      wrap.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-pdp-thumb]');
        if (!thumb) { return; }
        Gallery.show(thumb.getAttribute('data-media-id'));
      });
    },
    show: function (mediaId) {
      var main = $('[data-pdp-main]');
      if (!main) { return; }
      $$('img[data-media-id]', main).forEach(function (img) {
        img.style.display = img.getAttribute('data-media-id') === String(mediaId) ? '' : 'none';
      });
      $$('[data-pdp-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t.getAttribute('data-media-id') === String(mediaId) ? 'true' : 'false');
      });
    }
  };

  /* ===============================================================
   * PRODUCT CARDS — quick add, notes toggle, 360 image cycling
   * ============================================================= */
  var Cards = {
    init: function () {
      document.addEventListener('click', function (e) {
        var notes = e.target.closest('[data-notes-toggle]');
        if (notes) {
          var panel = document.getElementById(notes.getAttribute('aria-controls'));
          if (panel) {
            var open = panel.hasAttribute('hidden');
            if (open) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
            notes.setAttribute('aria-expanded', String(open));
            notes.textContent = notes.getAttribute(open ? 'data-label-hide' : 'data-label-show');
          }
          return;
        }

        var quick = e.target.closest('[data-quick-add]');
        if (quick) {
          e.preventDefault();
          /* Multi-variant products must choose options on the PDP,
             exactly like Shopify's own themes. */
          if (quick.getAttribute('data-needs-options') === 'true') {
            window.location.href = quick.getAttribute('data-product-url');
            return;
          }
          var card = quick.closest('[data-product-card]');
          var title = card ? card.getAttribute('data-product-title') : '';
          var original = quick.textContent;
          quick.disabled = true;
          Cart.add(quick.getAttribute('data-variant-id'), 1)
            .then(function () {
              toast('<strong>' + title + '</strong> ' + (STRINGS.to_cart || ''));
              Cart.open();
            })
            .catch(function (err) { toast(err.message || 'Could not add to cart'); })
            .then(function () { quick.disabled = false; quick.textContent = original; });
        }
      });

      /* Hover "360°" — cycles real product photography where the
         preview span the SVG bottle. Falls back to the spin animation
         automatically when a product has no images. */
      $$('[data-card-media][data-spin-frames]').forEach(function (media) {
        var frames = $$('img[data-frame]', media);
        if (frames.length < 2) { return; }
        var i = 0, timer = null;
        media.addEventListener('mouseenter', function () {
          timer = window.setInterval(function () {
            frames[i].style.display = 'none';
            i = (i + 1) % frames.length;
            frames[i].style.display = '';
          }, 550);
        });
        media.addEventListener('mouseleave', function () {
          window.clearInterval(timer);
          frames.forEach(function (f, n) { f.style.display = n === 0 ? '' : 'none'; });
          i = 0;
        });
      });
    }
  };

  /* ===============================================================
   * WISHLIST + COMPARE — handles only
   * ============================================================= */
  var Lists = {
    init: function () {
      Lists.paint();
      document.addEventListener('click', function (e) {
        var wish = e.target.closest('[data-wishlist-toggle]');
        if (wish) {
          var added = toggleInList(LS.wishlist, wish.getAttribute('data-handle'));
          Lists.paintButton(wish, added);
          return;
        }
        var cmp = e.target.closest('[data-compare-toggle]');
        if (cmp) {
          var handle = cmp.getAttribute('data-handle');
          var list = readList(LS.compare);
          if (list.indexOf(handle) === -1 && list.length >= MAX_COMPARE) {
            toast('Compare holds ' + MAX_COMPARE + ' chapters at a time.', 'compare');
            return;
          }
          var on = toggleInList(LS.compare, handle, MAX_COMPARE);
          Lists.paintButton(cmp, on);
          document.dispatchEvent(new CustomEvent('hoj:compare:changed'));
        }
      });
    },

    paintButton: function (btn, active) {
      btn.textContent = btn.getAttribute(active ? 'data-label-remove' : 'data-label-add');
      btn.classList.toggle('is-comparing', active && btn.hasAttribute('data-compare-toggle'));
      btn.classList.toggle('is-wishlisted', active && btn.hasAttribute('data-wishlist-toggle'));
      btn.classList.toggle('is-active', active);
    },

    paint: function (ctx) {
      var wl = readList(LS.wishlist);
      var cm = readList(LS.compare);
      $$('[data-wishlist-toggle]', ctx).forEach(function (b) {
        Lists.paintButton(b, wl.indexOf(b.getAttribute('data-handle')) > -1);
      });
      $$('[data-compare-toggle]', ctx).forEach(function (b) {
        Lists.paintButton(b, cm.indexOf(b.getAttribute('data-handle')) > -1);
      });
    }
  };

  /* ===============================================================
   * RECENTLY VIEWED — handles hydrated via Section Rendering API
   * ============================================================= */
  var Recent = {
    record: function (handle) {
      if (!handle) { return; }
      var list = readList(LS.recent).filter(function (h) { return h !== handle; });
      list.unshift(handle);
      writeList(LS.recent, list.slice(0, MAX_RECENT));
    },

    init: function () {
      var wrap = $('[data-recently-viewed]');
      if (!wrap) { return; }
      var row = $('[data-recently-viewed-row]', wrap);
      var currentHandle = ($('[data-product-section]') || {}).getAttribute
        ? $('[data-product-section]').getAttribute('data-product-handle')
        : null;

      var handles = readList(LS.recent).filter(function (h) { return h !== currentHandle; }).slice(0, 8);
      if (!handles.length) { return; }

      Promise.all(handles.map(function (handle) {
        return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=hoj-card-fragment')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (chunks) {
        var html = chunks.filter(Boolean).join('');
        if (!html.trim()) { return; }
        row.innerHTML = html;
        wrap.removeAttribute('hidden');
        Lists.paint(row);
      });
    }
  };

  /* ===============================================================
   * PREDICTIVE SEARCH — /search/suggest.json
   * ============================================================= */
  var Search = {
    init: function () {
      $$('[data-predictive-search]').forEach(function (form) {
        var input = $('[data-search-input]', form);
        var results = $('[data-search-results]', form);
        var scope = $('[data-search-scope]', form);
        if (!input || !results) { return; }

        var timer = null;
        var controller = null;

        function close() { results.setAttribute('hidden', ''); results.innerHTML = ''; }

        function run() {
          var term = input.value.trim();
          if (term.length < 2) { close(); return; }

          if (controller) { controller.abort(); }
          controller = new AbortController();

          results.removeAttribute('hidden');
          results.innerHTML = '<div class="nav-search-results__loading">' + (STRINGS.loading || '…') + '</div>';

          var q = term;
          if (scope && scope.value) { q += ' collection:' + scope.value; }

          var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
                    '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';

          fetchJSON(url, { signal: controller.signal })
            .then(function (data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              if (!products.length) {
                results.innerHTML = '<div class="nav-search-results__empty">' +
                  (STRINGS.no_results || 'No chapters found').replace('{{ terms }}', term) + '</div>';
                return;
              }
              results.innerHTML = products.map(function (p) {
                var img = p.featured_image && p.featured_image.url
                  ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '';
                var price = p.price != null ? formatMoney(p.price) : '';
                return '<a href="' + p.url + '">' + img +
                  '<span class="ps-body"><span class="ps-title">' + p.title + '</span></span>' +
                  '<span class="ps-price">' + price + '</span></a>';
              }).join('');
            })
            .catch(function (err) {
              if (err.name === 'AbortError') { return; }
              close();
            });
        }

        input.addEventListener('input', function () {
          window.clearTimeout(timer);
          timer = window.setTimeout(run, 220);
        });
        input.addEventListener('focus', function () { if (input.value.trim().length >= 2) { run(); } });

        document.addEventListener('click', function (e) {
          if (!form.contains(e.target)) { close(); }
        });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { close(); input.blur(); }
        });
      });

      /* Mobile search row toggle — mirrors the preview's behaviour. */
      var toggle = $('[data-search-mobile-toggle]');
      var row = $('[data-search-mobile-row]');
      if (toggle && row) {
        toggle.addEventListener('click', function () {
          var open = row.hasAttribute('hidden');
          if (open) { row.removeAttribute('hidden'); } else { row.setAttribute('hidden', ''); }
          toggle.setAttribute('aria-expanded', String(open));
          if (open) { var i = $('[data-search-input]', row); if (i) { i.focus(); } }
        });
      }
    }
  };

  /* ===============================================================
   * INDEX PANEL
   * ============================================================= */
  var Index = {
    init: function () {
      var toggle = $('[data-index-toggle]');
      var panel = $('[data-index-panel]');
      var overlay = $('[data-index-overlay]');
      if (!toggle || !panel) { return; }

      function set(open) {
        panel.classList.toggle('open', open);
        toggle.classList.toggle('open', open);
        toggle.setAttribute('aria-expanded', String(open));
        if (overlay) { overlay.classList.toggle('show', open); }
      }
      toggle.addEventListener('click', function () { set(!panel.classList.contains('open')); });
      if (overlay) { overlay.addEventListener('click', function () { set(false); }); }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); } });
    }
  };

  /* ---------------------------------------------------------------
   * Collection sort
   * ------------------------------------------------------------- */
  var Collection = {
    init: function () {
      var select = $('[data-collection-sort]');
      if (!select) { return; }
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  };


  /* ===============================================================
   * RECOMMENDATIONS — Shopify Product Recommendations API
   * ============================================================= */
  var Recommend = {
    init: function () {
      var el = $('[data-recommendations]');
      if (!el || !el.getAttribute('data-url')) { return; }
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html.trim()) { return; }
          var fresh = new DOMParser().parseFromString(html, 'text/html')
                        .querySelector('[data-recommendations]');
          if (!fresh || !fresh.querySelector('.product-grid')) { return; }
          el.innerHTML = fresh.innerHTML;
          el.removeAttribute('hidden');
          Lists.paint(el);
        })
        .catch(function () { /* recommendations are optional */ });
    }
  };

  /* ===============================================================
   * QUICK VIEW — real product JSON, no mock objects
   * ============================================================= */
  var QuickView = {
    init: function () {
      var overlay = $('[data-quickview-overlay]');
      if (!overlay) { return; }
      var body = $('[data-quickview-body]', overlay);

      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-quickview]');
        if (trigger) {
          e.preventDefault();
          QuickView.open(trigger.getAttribute('data-handle'));
          return;
        }
        if (e.target.closest('[data-quickview-close]') ||
            (e.target === overlay)) { QuickView.close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { QuickView.close(); }
      });

      QuickView.overlay = overlay;
      QuickView.body = body;
    },

    close: function () {
      if (QuickView.overlay) { QuickView.overlay.setAttribute('hidden', ''); }
    },

    open: function (handle) {
      if (!handle || !QuickView.overlay) { return; }
      QuickView.overlay.removeAttribute('hidden');
      QuickView.body.innerHTML = '<div class="quick-view__loading">' + (STRINGS.loading || '') + '</div>';

      fetchJSON(ROOT + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          var img = p.featured_image
            ? '<img src="' + p.featured_image + '" alt="' + (p.title || '') + '">' : '';
          var price = v.compare_at_price && v.compare_at_price > v.price
            ? '<span class="price__sale">' + formatMoney(v.price) + '</span>' +
              '<span class="price__compare">' + formatMoney(v.compare_at_price) + '</span>'
            : formatMoney(v.price);
          var opts = '';
          if (!(p.variants.length === 1 && p.variants[0].title === 'Default Title')) {
            opts = '<div class="pdp-swatches" style="margin-bottom:16px">' +
              p.variants.map(function (x) {
                return '<button type="button" class="pdp-swatch' + (x.available ? '' : ' is-unavailable') +
                  '" data-qv-variant="' + x.id + '" aria-pressed="' + (x.id === v.id) + '"' +
                  (x.available ? '' : ' disabled') + '>' + x.title + '</button>';
              }).join('') + '</div>';
          }
          QuickView.body.innerHTML =
            '<div class="quick-view__body">' +
              '<div class="quick-view__media">' + img + '</div>' +
              '<div>' +
                (p.vendor ? '<p class="quick-view__vendor">' + p.vendor + '</p>' : '') +
                '<h3 class="quick-view__title">' + p.title + '</h3>' +
                '<div class="quick-view__price" data-qv-price>' + price + '</div>' +
                opts +
                '<div class="quick-view__desc">' +
                  (p.description || '').replace(/<[^>]+>/g, '').slice(0, 260) +
                '</div>' +
                '<button type="button" class="btn btn-primary" data-qv-add data-variant-id="' + v.id + '"' +
                  (v.available ? '' : ' disabled') + '>' +
                  (v.available ? (STRINGS.add_to_cart || 'Add to Cart') : (STRINGS.sold_out || '')) +
                '</button>' +
                '<a class="btn-ghost-mini quick-view__full" href="' + p.url + '">' +
                  (STRINGS.view_full || '') + '</a>' +
              '</div>' +
            '</div>';

          QuickView.body.addEventListener('click', function (e) {
            var sw = e.target.closest('[data-qv-variant]');
            if (sw) {
              var id = Number(sw.getAttribute('data-qv-variant'));
              var nv = p.variants.filter(function (x) { return x.id === id; })[0];
              $$('[data-qv-variant]', QuickView.body).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
              sw.setAttribute('aria-pressed', 'true');
              var pe = $('[data-qv-price]', QuickView.body);
              if (pe && nv) {
                pe.innerHTML = nv.compare_at_price && nv.compare_at_price > nv.price
                  ? '<span class="price__sale">' + formatMoney(nv.price) + '</span>' +
                    '<span class="price__compare">' + formatMoney(nv.compare_at_price) + '</span>'
                  : formatMoney(nv.price);
              }
              var add = $('[data-qv-add]', QuickView.body);
              if (add && nv) { add.setAttribute('data-variant-id', nv.id); add.disabled = !nv.available; }
              return;
            }
            var addBtn = e.target.closest('[data-qv-add]');
            if (addBtn && !addBtn.disabled) {
              addBtn.disabled = true;
              Cart.add(addBtn.getAttribute('data-variant-id'), 1)
                .then(function () {
                  toast('<strong>' + p.title + '</strong> ' + (STRINGS.to_cart || ''));
                  QuickView.close(); Cart.open();
                })
                .catch(function (err) { toast(err.message || ''); })
                .then(function () { addBtn.disabled = false; });
            }
          });
        })
        .catch(function () { QuickView.close(); });
    }
  };

  /* ===============================================================
   * COMPARE MODAL — hydrated from real product JSON by handle
   * ============================================================= */
  var Compare = {
    init: function () {
      var bar = $('[data-compare-bar]');
      if (!bar) { return; }
      Compare.bar = bar;
      Compare.overlay = $('[data-compare-overlay]');
      Compare.render();

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-compare-clear]')) { writeList(LS.compare, []); Lists.paint(); Compare.render(); return; }
        if (e.target.closest('[data-compare-open]')) { Compare.open(); return; }
        if (e.target.closest('[data-compare-close]') || e.target === Compare.overlay) { Compare.close(); return; }
        var chip = e.target.closest('[data-compare-remove]');
        if (chip) {
          toggleInList(LS.compare, chip.getAttribute('data-handle'), MAX_COMPARE);
          Lists.paint(); Compare.render();
          if (Compare.overlay && !Compare.overlay.hasAttribute('hidden')) { Compare.open(); }
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { Compare.close(); } });
      document.addEventListener('hoj:compare:changed', Compare.render);
    },

    render: function () {
      var list = readList(LS.compare);
      var chips = $('[data-compare-chips]');
      if (!Compare.bar || !chips) { return; }
      if (!list.length) { Compare.bar.setAttribute('hidden', ''); return; }
      Compare.bar.removeAttribute('hidden');
      chips.innerHTML = list.map(function (h) {
        return '<span class="compare-bar__chip">' + h.replace(/-/g, ' ') +
               '<button type="button" data-compare-remove data-handle="' + h + '">&times;</button></span>';
      }).join('');
    },

    close: function () { if (Compare.overlay) { Compare.overlay.setAttribute('hidden', ''); } },

    open: function () {
      var list = readList(LS.compare);
      if (!list.length || !Compare.overlay) { return; }
      var body = $('[data-compare-body]', Compare.overlay);
      Compare.overlay.removeAttribute('hidden');
      body.innerHTML = '<div class="quick-view__loading">' + (STRINGS.loading || '') + '</div>';

      Promise.all(list.map(function (h) {
        return fetchJSON(ROOT + 'products/' + encodeURIComponent(h) + '.js').catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) { body.innerHTML = ''; return; }
        function row(label, cells) {
          return '<tr><td class="compare-table__label-col">' + label + '</td>' +
                 cells.map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>';
        }
        var head = '<tr><th class="compare-table__label-col"></th>' + products.map(function (p) {
          var img = p.featured_image
            ? '<div class="compare-table__bottle"><img src="' + p.featured_image + '" alt=""></div>' : '';
          return '<th>' + img +
            '<div class="compare-table__name">' + p.title + '</div>' +
            '<button type="button" class="compare-table__remove" data-compare-remove data-handle="' +
              p.handle + '">' + (STRINGS.compare_remove || 'Remove') + '</button></th>';
        }).join('') + '</tr>';

        body.innerHTML = '<table class="compare-table">' + head +
          row(STRINGS.compare_price || 'Price', products.map(function (p) { return formatMoney(p.price); })) +
          row(STRINGS.compare_vendor || 'Vendor', products.map(function (p) { return p.vendor || '—'; })) +
          row(STRINGS.compare_availability || 'Availability', products.map(function (p) {
            return p.available ? (STRINGS.in_stock || '') : (STRINGS.sold_out || '');
          })) +
          row('', products.map(function (p) {
            return '<a class="btn-ghost-mini" href="' + p.url + '">' + (STRINGS.view_full || '') + '</a>';
          })) +
          '</table>';
      });
    }
  };

  /* ---------------------------------------------------------------
   * Boot
   * ------------------------------------------------------------- */
  function boot() {
    Cart.init();
    Gallery.init();
    Product.init();
    Cards.init();
    Lists.init();
    Recent.init();
    Search.init();
    Index.init();
    Collection.init();
    Recommend.init();
    QuickView.init();
    Compare.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', boot);

  window.HOJ = window.HOJ || {};
  window.HOJ.cart = Cart;
  window.HOJ.formatMoney = formatMoney;
})();
